/* eslint-disable @typescript-eslint/naming-convention */
import { IProduct } from '@commerce-product-webcomponents/sdk';
import { PlanResponse, Plans, SubcriptionPlanCMSResponseType } from '@commerce-subscription-webcomponents/sdk';

export interface SubscriptionSelectionPropsTypes {
  subscriptionPlans: Plans;
  showSubscribeButton: (showButton: boolean) => void;
  purchaseType?: PurchaseTypes;
  /**
   * @deprecated productId will be removed in future version use productId from productData
   */
  productId?: string;
  productData: IProduct;
}

export enum PurchaseTypes {
  ONETIME = 'oneTime',
  SUBSCRIPTION = 'subscription',
}

export type PlanResponseWithTag = PlanResponse & {
  planTag?: SubcriptionPlanCMSResponseType['plan_tag'];
};
